import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import PatientsChart from "./components/PatientsChart";
import PatientsSeen from "./components/PatientsSeen";
import Queue from "./components/Queue";
import RecentRequests from "./components/RecentRequests";
import TotalRequests from "./components/TotalRequests";
import Visits from "./components/Visits";
import useAxios from "../../../../Hooks/useAxios";
import useApp from "../../../../Hooks/useApp";
import Requests from "./components/Requests";

const Summary = () => {
  const [recentRequests, setRecentRequests] = useState([]);
  const [requests, setRequests] = useState([]);
  const [mVisits, setMVisits] = useState([]);
  const [totalRequests, setTotalRequests] = useState(0);
  const [patientsSeen, setPatientsSeen] = useState(0);
  const [queue, setQueue] = useState(0);
  const [userQueue, setUserQueue] = useState([]);
  const [lab, setLab] = useState(0);
  const [wVisits, setWVisits] = useState([]);
  const { user, setIsLoading } = useApp();
  const [loading, setLoading] = useState(false);
  const request = useAxios();

  async function getInitialData() {
    setIsLoading(true);
    try {
      let res = await request({
        method: "GET",
        url: "hospital/analytics/triage",
        params: {
          user_id: parseInt(user.id),
          year: new Date().getFullYear(),
        },
      });

      if (res === "error") {
        return;
      }

      setRecentRequests(res.recent_requests);
      setTotalRequests(res.total_requests);
      setQueue(res.total_triage_queues.total_triage_user_queue);
      setPatientsSeen(res.patients_seen_today);
      setLab(res.patients_in_lab);
      setRequests(res.requests);
      setMVisits(res.monthly_patients);
      setWVisits(res.weekly_patients);
      setUserQueue(res.total_triage_queues.total_triage_user_queue);
      setIsLoading(false);
    } catch (e) {
      //console.log(e);
    }
  }

  useEffect(() => {
    getInitialData();
  }, []);

  return (
    <div className="w-full  bg-ghost_white">
      <div className="h-full px-10 ">
        <Navbar />
      </div>
      <div className="flex justify-between gap-x-5 py-10 px-10 bg-ghost_white w-full">
        <div className="w-9/12 ">
          <PatientsSeen patientsSeen={patientsSeen} queue={queue} lab={lab} />
        </div>
        <div className="w-3/12 mx-auto">
          <TotalRequests totalRequests={totalRequests} />
        </div>
      </div>
      <div className="flex justify-between gap-x-5 p-10 w-full bg-ghost_white">
        <div className="w-7/12">
          <PatientsChart mVisits={mVisits} />
        </div>
        <div className="w-4/12 mx-auto">
          <Requests requests={requests} />
        </div>
      </div>
      <div className="flex justify-between gap-x-5 mb-10 p-10 w-full bg-ghost_white">
        <div className="w-8/12">
          <Queue userQueue={userQueue} />
        </div>
        <div className="w-4/12">
          <RecentRequests recentRequests={recentRequests} />
        </div>
      </div>
    </div>
  );
};

export default Summary;
